<template>
  <div class="d-flex justify-content-center">
    <div>
      <iframe :src="linkedinURL" height="471" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
    </div>
  </div>
</template>

<script>
import ExternalMediaObject from './ExternalMediaObject'
export default {
  name: 'LinkedInObject',
  mixins: [ExternalMediaObject],
  computed: {
    linkedinURL () {
      return 'https://www.linkedin.com/embed/feed/update/urn:li:share:' + this.mediaObject.id
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/socialMedia/LinkedInObject.vue